import { Flex, Text } from '@approvalmax/ui/src/components';
import { memo } from 'react';

import { BudgetParamsProps } from './BudgetParams.types';

export const BudgetParams = memo<BudgetParamsProps>((props) => {
    const { company, params, isBudgetDisabled } = props;

    const { hasActiveIntegration } = company.flags;

    const budgetDisabled = !hasActiveIntegration || isBudgetDisabled;

    return (
        <Flex direction='column' spacing='8'>
            {params.map(({ id, label, value }) => (
                <Flex container spacing='8' wrap={false} key={id}>
                    <Flex size={10}>
                        <Text font='label' fontSize='small' color='midnight70'>
                            {label}
                        </Text>
                    </Flex>

                    <Flex size={14}>
                        <Text font='label' fontSize='small' color={budgetDisabled ? 'midnight70' : undefined}>
                            {value}
                        </Text>
                    </Flex>
                </Flex>
            ))}
        </Flex>
    );
});

BudgetParams.displayName = 'BudgetParams';
